import React, { createContext, useState, useEffect, useContext } from "react";

//CONSTANT
import { USER_DEAFULT_KEY } from "../constant/event";

//API
import { SET_CERTIFICATE_NAME } from "../api/firebase_user";

export const BundleContext = createContext();

export const BundleProvider = (props) => {
  const [selectedCertificate, setSelectedCertificate] = useState("");

  useEffect(() => {
   
    const getSelectedBundle = async () => {
      const result = localStorage.getItem(
        USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS
      );
      
      // Set a default bundle if none is selected
      if (!result) {
        // Default to CISSP if no bundle is saved
        const defaultBundle = "cissp";
        localStorage.setItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS, defaultBundle);
        setSelectedCertificate(defaultBundle);
      } else {
        setSelectedCertificate(result);
      }
    };

    getSelectedBundle();
  }, []);

  async function setSelectedBundle(key) {
    localStorage.setItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS, key);
    await SET_CERTIFICATE_NAME(key);
    setSelectedCertificate(key);
    return;
  }

  return (
    <BundleContext.Provider
      value={{
        selectedCertificate,
        setSelectedBundle,
      }}
    >
      {props.children}
    </BundleContext.Provider>
  );
};
